import { Injectable } from "@angular/core";
import { PessoaJuridica } from "@tivic-team/manager-ts/dist/grl";
import { PessoaJuridicaController } from "app/controllers/grl/pessoa-juridica.controller";
import { PagedResponse } from "app/interfaces/paged-response.inteface";
import { PessoaJuridicaDTO } from "app/model/dtos/grl/pessoa-juridica.dto";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { PessoaJuridicaSearch } from "./pessoa-juridica.search";

@Injectable()
export class PessoaJuridicaService implements ApiService<PessoaJuridica> {
    constructor(
        private _pessoaJuridicaController: PessoaJuridicaController,
        private _loaderService: LoaderService
    ) { }

    async find(search?: PessoaJuridicaSearch): Promise<PessoaJuridica[] | PagedResponse<PessoaJuridica>> {
            return await this._pessoaJuridicaController.getPermissionario(search && search.getFilters() || null)
                .finally(() => this._loaderService.hide());
    }

    get(...args: number[]): Promise<PessoaJuridica> {
        throw new Error("Method not implemented.");
    }
    create(entity: PessoaJuridica): Promise<PessoaJuridica> {
        throw new Error("Method not implemented.");
    }
    update(entity: PessoaJuridica): Promise<PessoaJuridica> {
        throw new Error("Method not implemented.");
    }

    async getPermissionario(pessoaJuridicaSearch?: PessoaJuridicaSearch): Promise<PessoaJuridica[]> {
            return await this._pessoaJuridicaController.getPermissionario(pessoaJuridicaSearch && pessoaJuridicaSearch.getFilters() || null)
                .finally(() => this._loaderService.hide());
    }

    async getPessoaByCNPJ(nrCNPJ:string):Promise<PessoaJuridicaDTO>{
        this._loaderService.show();
        return this._pessoaJuridicaController.getPessoaByCNPJ(nrCNPJ).finally(() => this._loaderService.hide());
    }
}